import { createSelector } from '@ngrx/store'


import { AppState } from '../../../../store'
import * as fromConvTeam from '../reducers/conversation-team.reducer'

export const selectConversationTeamState = createSelector(
  (state: AppState) => state.conversationTeam,
  _ => _
)

export const {
  selectIds: getConversationTeamIds,
  selectEntities: getConversationTeamEntities,
  selectAll: getConversationTeamsSelector,
  selectTotal: getTotalConversationTeams,
} = fromConvTeam.adapter.getSelectors(selectConversationTeamState)

export const getSwitchedTeamIdSelector = createSelector(
  selectConversationTeamState,
  fromConvTeam.getSwitchedTeamId
)

export const getOpenConversationsSelector = createSelector(
  selectConversationTeamState,
  (state: fromConvTeam.State) => {
    const team = state.entities[state.switchedTeamId]
    if (!team || !team.conversations) {
      return 0
    }
    return team.conversations.count
  })



// WEBPACK FOOTER //
// ./src/app/shared/team/store/selectors/conversation-team.selectors.ts